import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: {},
    if_class: 0,
    className: '',
    day1: 0,
    day2: 0,
    day3: 0,
    is_auth: 0,
    //mer_id: ''
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },

    setUserInfo(state, userinfo) {
      state.userInfo = userinfo
    },

    setClass(state, if_class){
      state.if_class = if_class
    },
    setClassName(state, className){
      state.className = className
    },
    setAuth(state, auth){
      state.is_auth = auth
    },
    setDay1(state, day){
      state.day1 = day
    },
    setDay2(state, day){
      state.day2 = day
    },
    setDay3(state, day){
      state.day3 = day
    },
    // setMerId(state, mer_id){
    //   state.mer_id = mer_id
    // },
  },
  actions: {
    
  },
  getters: {
   
  },
  plugins: [persistedState()]
})
